import { render } from "./FPThreadsContainer.vue?vue&type=template&id=03b5f46c&ts=true"
import script from "./FPThreadsContainer.ts?vue&type=script&lang=ts&external"
export * from "./FPThreadsContainer.ts?vue&type=script&lang=ts&external"

import "./FPThreadsContainer.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__